var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.$store.getters.showLoader)?_c('loader',{attrs:{"data":_vm.$store.getters.loaderMessage}}):_vm._e(),(_vm.$store.getters.showAlert)?_c('snakBar',{attrs:{"status":_vm.$store.getters.showAlert,"message":_vm.$store.getters.alertMessage,"color":_vm.$store.getters.alertColor}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }